<script lang="ts">
	import { format } from 'svelte-i18n';
	import { capFirstChar } from 'src/helpers/utilities';
	import { Alert, Text } from '@Shelly/shelly-design-system';
	import { getBleFilterDeviceByModel } from 'src/helpers/web_bluetooth/web_bluetooth_device_filter';
	import TransitionWrapper from '../Utility/TransitionWrapper.svelte';
	import BleWebInclusionSelectList from './BleWebInclusionSelectList.svelte';

	export let filterPrefix: string;
	export let connectionError: string;

	const filterOptions = getBleFilterDeviceByModel();
</script>

{#if connectionError}
	<Alert
		class="mb-s"
		type="danger"
		heading={capFirstChar(
			$format('alert_title_ble_pair_prompt', {
				default: 'Pairing required',
			}),
		)}
		message={connectionError}
	/>
{/if}
<Alert
	heading={capFirstChar(
		$format('alert_title_ble_pair_prompt', {
			default: 'Pairing required',
		}),
	)}
	message={capFirstChar(
		$format('alert_message_ble_pair_init', {
			default:
				'If you try to include BLE or a sleeping device, please press the device button before continuing.',
		}),
	)}
/>
<Text element="h2" class="mt-m mb-s">
	{$format('text_ble_pair_scan_devices_by_models', {
		default: 'Scan devices by models',
	})}
</Text>
<TransitionWrapper>
	<BleWebInclusionSelectList bind:filterPrefix list={filterOptions} />
</TransitionWrapper>
